export default (server) => { return new AuthRepository(server) }

function AuthRepository(server){ this.server = server }

AuthRepository.prototype = {
  constructor: AuthRepository,

  signUp (registration) { return this.server.post('sign-up', registration) },
  verifyEmailAddress (token) { return this.server.post('verify-email-address', {token: token}) },
  signIn (credentials) { return this.server.post('sign-in', credentials) },
  resetPassword (emailAddress) { return this.server.post('reset-password', {emailAddress: emailAddress}) },
  verifyResetPasswordToken (token) { return this.server.post('reset-password', {token: token})},
  setPassword (token, password) { return this.server.post('reset-password', {token: token, password: password})}
}
